import React, { useState, useEffect, useRef, useContext  } from "react";
import DatafeedCE from "./datafeed-CE";
import DatafeedPE from "./datafeed-PE";
import DatafeedSpot from "./datafeed-Spot";
import Centrifuge from "centrifuge";
import moment from "moment";
import { Type } from "ajv/dist/compile/subschema";
import AppContext from "../../../../context/Context";
import { getTicksData, getPrice } from "../../../../redux/actions/optionChain";

import { 
  saveChartApiRequest, 
  getAllChartsApiRequest, 
  removeChartApiRequest, 
  getChartContentApiRequest,
  saveStudyTemplateApiRequest,
  getAllStudyTemplatesApiRequest,
  getStudyTemplateContentApiRequest,
  removeStudyTemplateApiRequest
 } from "./study-template";
import { getTokenBySymbol } from "./helpers";
import { custom_indicators_getter } from "./customIndicator";


const Charts = ({
    height,
    type,
    headingText,
    width,
    info,
    inputValues,
    instrument,
    splitScreen,
    dragging,
    onTradeStatusChange,
    token
}) => {
  const {
    config: { isDark },
  } = useContext(AppContext);

  const chartContainerRef = useRef(null);
  const TVcharts = useRef(null);
  const lastInstrumentRef = useRef(null);
  const [source, setSource] = useState(() => {});
  const [subscription, setsubscription] = useState(() => {});
  const [isChartReady, setIsChartReady] = React.useState(false);
  const [containerHeight, setcontainerHeight] = React.useState(0);
  const [currentSymbol, setCurrentSymbol] = useState(null);

 // connecting to socket data
 useEffect(() => {
  const centrifuge = new Centrifuge(
    process.env.REACT_APP_API_FEED
  );

  centrifuge.on("connect", function (ctx) {
    console.log(
      "Connected with client ID " + ctx.client + " over " + ctx.transport
    );
  });

  centrifuge.on("disconnect", function (ctx) {
    console.log(
      "Disconnected: " +
        ctx.reason +
        (ctx.reconnect
          ? ", will try to reconnect"
          : ", won't try to reconnect")
    );
  });

  centrifuge.connect();
  setSource(centrifuge);

  // setConfig('isNavbarVerticalCollapsed', !isNavbarVerticalCollapsed);
}, []);

// Check if instrument is tradeable
useEffect(() => {
  const checkTradeStatus = async () => {
    
    const tokenToCheck = currentSymbol || token; 
    
    if (tokenToCheck && tokenToCheck !== lastInstrumentRef.current) {
      lastInstrumentRef.current = tokenToCheck;
      try {
        const response = await getTicksData(tokenToCheck);
        
        if (response && response[tokenToCheck]?.isTrade !== undefined) {
          const isTradeableStatus = response[tokenToCheck]?.isTrade === true;
          
          if (onTradeStatusChange) {
            onTradeStatusChange(type, isTradeableStatus);
          }
        } else {
          if (onTradeStatusChange) {
            onTradeStatusChange(type, false);
          }
        }
      } catch (error) {
        console.error('Error checking trade status:', error);
        if (onTradeStatusChange) {
          onTradeStatusChange(type, false);
        }
      }
    } else if (!tokenToCheck) {
      console.log(`No instrument token available for ${type}`);
      lastInstrumentRef.current = null;
    }
  };

  checkTradeStatus();
}, [currentSymbol, token, type]);


 
useEffect(() => {
   if (!isChartReady) return;
   if (isDark) {


      //TVcharts?.current?.setCSSCustomProperty('--tv-color-pane-background', 'rgb(251, 223, 244)')
    //  TVcharts?.current?.setCSSCustomProperty('--tv-color-platform-background', 'rgb(251, 223, 244)')
    TVcharts?.current?.changeTheme('Dark').then(() => {
      TVcharts?.current?.chart().applyOverrides({ 'paneProperties.backgroundGradientStartColor': '#0b1727' });
      TVcharts?.current?.chart().applyOverrides({ 'paneProperties.background': '#0b1727' });
      TVcharts?.current?.chart().applyOverrides({ 'paneProperties.backgroundGradientEndColor': '#0b1727' });
      TVcharts?.current?.setCSSCustomProperty('--tv-color-pane-background', '#0b1727')

    });

   } else {
     TVcharts?.current?.changeTheme("Light").then(() => {
      TVcharts?.current?.setCSSCustomProperty('--tv-color-pane-background', '#fff')
    });
   }
 }, [isDark, isChartReady, TVcharts]);
   
  useEffect(() => {

   if(document.fullscreenElement) {
    return;
   }

    if (!window?.TradingView  ) {
 
      return;
    }
    setIsChartReady(false);
     const containerWidth = chartContainerRef?.current?.offsetWidth;
    const containerHeight = chartContainerRef?.current?.offsetHeight;
    const storedSymbol = instrument;
    const storedInterval = 5
    const theme = isDark ? 'dark' : 'light'; // 
    const storedChartType = 1;
 
    window.tvWidget = new window.TradingView.widget({
      symbol: storedSymbol, // default symbol >>>>>>> When sending this from outside, this is the place you need to hook the token.
      interval: storedInterval, // default interval
      type: storedChartType, // default chart type
      width:   "100%",
      height:  "100%",
      container: "tv_chart_container-"+type,
      datafeed: type==="CE" ? DatafeedCE : type==="PE" ? DatafeedPE : DatafeedSpot,
      library_path: "../charting_library/",
      timezone: "Asia/Kolkata",
      fullscreen: false,
      theme: theme, 
      autosize: true,
      load_last_chart:true,
      enabled_features: ["study_templates"],
      disabled_features: [
        "header_symbol_search", 
        "symbol_search_hot_key",
        "symbol_info",
        "edit_buttons_in_legend",
        "timeframes_toolbar",
      ],
     custom_indicators_getter: custom_indicators_getter,
    
    save_load_adapter: {
        charts: [],
        studyTemplates: [],
        drawingTemplates: [],
        chartTemplates: [],
        drawings: {},
        saveChart: async function(chartData) {
          if (!chartData.id) {
              chartData.id = Math.random().toString();
          } 
          const data = await saveChartApiRequest(chartData);
          if(data?.code == 200) {
            return Promise.resolve(data?.id);
          } else {
            return Promise.reject();
          }
        },
        getAllCharts: async function() {
            const data = await getAllChartsApiRequest();
            const d  =  Promise.resolve(data?.data)
            return Promise.resolve(d);;
        },
        removeChart: async function(id) {
          const data = await removeChartApiRequest(id);
          if(data?.code == 200) {
            return Promise.resolve();
          } else {
            return Promise.reject();
          }
        },

        getChartContent: async function(id) {
          const data = await getChartContentApiRequest(id);
          if(data?.code == 200) {
            return Promise.resolve(data?.data?.content);
          } else {
            return Promise.reject();
          }
         
        },
        
        saveStudyTemplate: async function(studyTemplateData) {
          const data = await saveStudyTemplateApiRequest(studyTemplateData);
          if(data?.code == 200) {
            return Promise.resolve(data?.id);
          } else {
            return Promise.reject();
          }
        },

        getAllStudyTemplates: async function() {
          const data = await getAllStudyTemplatesApiRequest();
          return Promise.resolve(data?.data);
        },

        removeStudyTemplate: async function(studyTemplateData) {
          const data = await removeStudyTemplateApiRequest(studyTemplateData.name);
          if(data?.code == 200) {
            return Promise.resolve();
          } else {
            return Promise.reject();
          }
        },

        getStudyTemplateContent : async function(studyTemplateData) {
          const data = await getStudyTemplateContentApiRequest(studyTemplateData.name);
          if(data?.code == 200) {
            return Promise.resolve(data?.data?.content);
          } else {
            return Promise.reject();
          }
         
        },
      },

       
    });


    TVcharts.current = window.tvWidget;
    TVcharts.current.onChartReady(function () {
      setIsChartReady(true);
      
      // Symbol change listener removed to prevent symbol changes
      // const getChartSymbol = async() => {
      // try {
      //   TVcharts.current.activeChart().onSymbolChanged().subscribe(null, async function(symbolInfo) {
      //     const token = await getTokenBySymbol(symbolInfo.ticker)
      //     setCurrentSymbol(token);
      //   });
      // } catch (error) {
      //   console.error('Error setting up symbol change listener:', error);
      // }
      // }
      // getChartSymbol()
    
    })
     
    return () => {
      try {
        TVcharts.current.activeChart().onSymbolChanged().unsubscribeAll();
        TVcharts.current.activeChart().onIntervalChanged().unsubscribeAll();
        TVcharts.current.activeChart().onChartTypeChanged().unsubscribeAll();
        TVcharts.current = null;
      } catch (e) {
        //fail silently
      }
    };
  }, [splitScreen, headingText, type,  instrument]);
   
 
 useEffect(() => {
    if (!window.tvWidget || !isChartReady) return;

    if(height) {
      document.getElementById(`strike-chart-main`).style.height = height;
    }

  }, [height]); 
  
  return (
    <div className="">
    <div id={`strike-chart-main`}>
       <div
          ref={chartContainerRef}
          style={{
            width: "100%",
            height: `${height+'px'}`
          }}
        >
          <div
            id={`tv_chart_container-`+type}
            style={{
              width: "100%",
              height: `${height+'px'}`
            }}
          ></div>
        </div>
    </div>
     
    </div>
  );
};

export default Charts;